import { render, staticRenderFns } from "./data25.vue?vue&type=template&id=c81d236a&scoped=true&"
import script from "./data25.vue?vue&type=script&lang=js&"
export * from "./data25.vue?vue&type=script&lang=js&"
import style1 from "./data25.vue?vue&type=style&index=1&id=c81d236a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d236a",
  null
  
)

export default component.exports